let postLoginSideBar = [

    { menu: { label: 'My Portfolio', linkTo: `/dashboard`, class: "myportfolio_navicon" }, },    
    {
        menu: { label: 'Invest', linkTo: ``, class: "invest_navicon" },
        subMenu: [
            { menu: { label: 'Basket Investment', linkTo: `/dashboard/transact/category`, class: "xyz" }, },
            { menu: { label: 'Lumpsum', linkTo: `/dashboard/transact/invest`, class: "xyz" }, },
            { menu: { label: 'Lumpsum - Cashflow', linkTo: `/dashboard/transact/investCash`, class: "xyz" }, },
            { menu: { label: 'SIP', linkTo: `/dashboard/transact/sip`, class: "xyz" }, },           
        ]
    },
    {
        menu: { label: 'Scheduled Investments', linkTo: ``, class:"mnschedule_navicon" },
        subMenu: [
            {
                menu: {
                    label: 'SIP', linkTo: '/dashboard/systematicPlan', class: "_ac"
                }
            },
        ]
    },
    {
        menu: { label: 'Reports', linkTo: ``, class: "report_navicon" },
        subMenu: [
            { menu: { label: 'SIP Reports', linkTo: `/dashboard/reports/SIPReport`, class: "_ac" }, },
            /* { menu: { label: 'Capital Gain / Loss Statement', linkTo: `/dashboard/reports/gainloss`, class: "_ac" }, }, */
            { menu: { label: 'Account Statement', linkTo: `/dashboard/reports/accountstatement`, class: "_ac" }, }
        ]
    },
    {
        menu: { label: 'Manage Account', linkTo: ``, class: "manageac_navicon" },
        subMenu: [
            { menu: { label: 'Add Bank', linkTo: `/dashboard/manageaccount/addbankaccount`, class: "_ac" }, },
            { menu: { label: 'Add Mandate', linkTo: `/dashboard/manageaccount/addmandate`, class: "_ac" }, },

        ]
    }
];

export default postLoginSideBar;